Librarian.Modules.Module = new Class({
    Implements: Options,
    Binds: ["destroy", "load"],

    options: {
        title: null,
        subTitle: null,
        titleOnClick: null,
        classPrefix: null,
        addClass: null,
        id: null,
        height: null,
        minHeight: null,
        onPreRender: null,
        onPreDestroy: null
    },

    wrapperEl: null,
    headerEl: null,
    containerEl: null,
    titleEl: null,

    destroyWrapper: false,

    request: null,
    onPreRender: null,

    initialize: function(options, wrapperEl, destroyWrapper, onLoaded) {
        this.setOptions(options);
        this.wrapperEl = wrapperEl;
        this.destroyWrapper = !!destroyWrapper;
        if(onLoaded) { this.onLoaded = onLoaded; }
    },

    destroy: function() {
        if (typeof this.options.onPreDestroy == "function")
            this.options.onPreDestroy.apply(this);

        if (this.request) {
            this.request.cancel();
            this.request = null;
        }

        var elements = [this.headerEl, this.containerEl];
        for (var i = elements.length; i--;) {
            if (elements[i]) {
                $(elements[i]).destroy();
                elements[i] = null;
            }
        }

        // Only destroy the wrapper if we explicitly tell it to
        if (this.wrapperEl && this.destroyWrapper) {
            $(this.wrapperEl).destroy();
            this.wrapperEl = null;
        }
    },

    load: function() {
        if (!this.wrapperEl)
            return;

        var id = this.options.id,
            title = this.options.title,
            subTitle = this.options.subTitle;

        this.wrapperEl.empty();
        this.wrapperEl.addClass(this.getClassName("wrapper"));

        if (this.options.addClass)
            this.wrapperEl.addClass(this.options.addClass);

        if (this.request) {
            this.request.cancel();
            this.request = null;
        }

        if (title != null) {
            if (typeOf(title) == "object" && title.template) {
                var titleTemplate = Handlebars.compile(title.template);
                title = this.options.title = titleTemplate(title);
            }

            if ((typeof title == "string") && (title.length > 0)) {
                this.headerEl = new Element("div", {
                    "class": this.getClassName("header")
                }).injectInside(this.wrapperEl);

                this.titleEl = new Element("span", {
                    "html": Librarian.Lang.getString(title),
                    "data-translation": title,
                    "class": this.getClassName("header-text")
                }).injectInside(this.headerEl);
            }

            if (title !== null && typeof titleOnClick == 'function') {
                this.titleEl.addOnClick(titleOnClick);
                this.titleEl.addClass("title-link");
            }

            if (subTitle) {
                if (typeof subTitle == "string" && subTitle.length > 0) {
                    new Element("span", {
                        "html": Librarian.Lang.getString(subTitle),
                        "class": this.getClassName("sub-header")
                    }).injectInside(new Element("div", {
                        "class": this.getClassName("sub-header-wrapper")
                    }).injectInside(this.headerEl));
                }
            }
        }

        this.containerEl = new Element("div", {
            "class": this.getClassName("container")
        }).injectInside(this.wrapperEl);

        // Set an ID on the container
        if (typeof id == "string") {
            this.containerEl.id = "module_" + id;
            // Don't overwrite an ID if there already is one
            if ((typeof this.wrapperEl.id != "string") || (this.wrapperEl.id.length == 0))
                this.wrapperEl.id = "module_" + id + "_wrapper";

            if (this.headerEl)
                this.headerEl.id = "module_" + id + "_header";
        }

        // Run the onPreRender
        if (typeof this.onPreRender == "function")
            this.onPreRender.apply(this);
        if (typeof this.options.onPreRender == "function")
            this.options.onPreRender.apply(this);

        if (typeof this.options.minHeight == "number")
            this.containerEl.setStyle("minHeight", this.options.minHeight + "px");

        if (typeof this.options.height === "string")
            this.containerEl.setStyle("height", this.options.height);
        else {
            var height = this.options.height || this.wrapperEl.getHeight();

            // Get the height of the header and, using that,
            // figure out the height of the container
            var headerHeight = this.headerEl ? this.headerEl.getHeight() : 0,
                contHeight = height - headerHeight;

            // If something went wrong, just forget about setting the height
            if (isNaN(contHeight))
                return;
                
            if (contHeight > 0)
                this.containerEl.setStyle("height", contHeight + "px");
            
            this.wrapperEl.setStyle("height", this.options.height + "px");
        }

        // execute callback if provided
        if(this.onLoaded) { this.onLoaded(); }
    },

    getClassName: function(suffix) {
        var className = "modules-" + suffix;

        if (this.options.classPrefix)
            className += " " + this.options.classPrefix + suffix;

        return className;
    }
});